import { render } from "./신장내과.vue?vue&type=template&id=b9d66b98"
import script from "./신장내과.vue?vue&type=script&lang=js"
export * from "./신장내과.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__